import Pravinya from "../images/pravinya.png";
import CuraLinkCert from "../images/curalink-certificate.png";
import HackerRankMayCert from "../images/hackerrank-may-certificate.png";
import HackerRankJuneCert from "../images/hackerrank-june-certificate.png";
import HackerRankAugCert from "../images/hackerrank-august-certificate.png";
import HackerRankSeptCert from "../images/hackerrank-september-certificate.png";
import HackerRankOctCert from "../images/hackerrank-october-certificate.gif";

export const Bio = {
  name: "Vivek Marakumbi",
  roles: ["GenAI Engineer", "AI Engineer", "ML Engineer", "Data Scientist"],
  description:
    "I am a driven and adaptable person, constantly seeking new challenges. My enthusiasm for acquiring new knowledge is matched by my commitment to producing excellent outcomes. Armed with a positive outlook and a mindset geared towards growth, I am prepared to make significant contributions and accomplish remarkable achievements.",

  // About section fields
  school: "KLE Technological University",
  schoolYears: "2020-2024",
  interests: ["Loves building", "Loves reading", "Loves playing cricket"],

  github: "https://github.com/VIVPM",
  resume:
    "https://drive.google.com/file/d/1TW8Au7sZ5DjeVbRnOTjWZM2Gyk2KuPnj/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/marakumbi-vivek/",
  email: "vivek.pmarakumbi@gmail.com",
  // twitter: "",
  // insta: "https://www.instagram.com/vivek_marakumbi/",
  // facebook: "",
};

// The Connect section's card row. `icon` keys map to components in
// components/Contact; `tint` is the brand colour used on that card's CTA.
export const connectLinks = [
  {
    id: "resume",
    icon: "resume",
    title: "Resume",
    subtitle: "Full adventure log.",
    cta: "Loot",
    href: Bio.resume,
    tint: "#b8860b",
  },
  {
    id: "linkedin",
    icon: "linkedin",
    title: "LinkedIn",
    subtitle: "Join the party.",
    cta: "Connect",
    href: Bio.linkedin,
    tint: "#0a66c2",
  },
  {
    id: "email",
    icon: "email",
    title: "Email",
    subtitle: "Send ravens.",
    cta: "Message",
    href: `mailto:${Bio.email}`,
    tint: "#e07a2a",
  },
  {
    id: "github",
    icon: "github",
    title: "GitHub",
    subtitle: "Read the spellbook.",
    cta: "Browse",
    href: Bio.github,
    tint: "#24292e",
  },
];

// The About section's "Achievements Unlocked" medallion row. Badge carries the
// number or grade, the label carries just enough context — no full sentences.
// Ordered strongest first.
export const achievements = [
  // Gold Medal parked for now, not removed. Restore by uncommenting.
  // {
  //   id: 0,
  //   badge: "GOLD",
  //   label: "Gold Medal, academic excellence in B.E. CSE",
  //   tint: "#d4af37",
  // },
  {
    id: 7,
    badge: "#10",
    label: "HackerRank Orchestrate September, 3,000+ participants",
    tint: "#9be96b",
  },
  {
    id: 6,
    badge: "#30",
    label: "HackerRank Orchestrate August, 1,900+ participants",
    tint: "#d9a441",
  },
  {
    id: 2,
    badge: "#30",
    label: "HackerRank Orchestrate June, 1700+ participants",
    tint: "#d9a441",
  },
  {
    id: 3,
    badge: "#59",
    label: "HackerRank Orchestrate May, 1,300+ participants",
    tint: "#b8763f",
  },
  {
    id: 8,
    badge: "#82",
    label: "HackerRank Orchestrate October, 4,000+ participants",
    tint: "#9be96b",
  },
  {
    id: 1,
    badge: "#4",
    label: "CuraLink Hackathon v2.0, Humanity Founders",
    tint: "#c9754a",
  },
  {
    id: 4,
    badge: "1000",
    label: "AWS Certified AI Practitioner, out of 1000",
    tint: "#7a8fa6",
  },
  // Kaggle badge parked for now.
  // {
  //   id: 5,
  //   badge: "#1233",
  //   label: "Kaggle Playground S6E2, 4,000+ participants",
  //   tint: "#5a8a5a",
  // },
];

// Core skills for the compact About profile.
export const skills = [
  "Python",
  "SQL",
  "FastAPI",
  "LangChain",
  "LlamaIndex",
  "RAG",
  "AI Agents",
  "RAGAS",
  "Hugging Face",
  "Pinecone",
  "Supabase",
  "Git",
  "Docker",
  "CI/CD",
  "LangFuse",
  "AWS",
  "Modal",
  "Model Deployment",
];

// Competitions, hackathons and published tools — the work that sits outside
// a job title. Rendered under the Experience section, not as its own nav stop.
export const activities = [
  {
    text: "Finished 82nd among 4,000+ participants in the HackerRank Orchestrate October edition. Built deletion-audit agent using identity tracing and evidence-backed checks to find leftover personal data and plan remediation.",
    links: [
      {
        kind: "github",
        href: "https://github.com/VIVPM/hackerrank-ghost-data-still-exists",
      },
      {
        kind: "certificate",
        href: HackerRankOctCert,
      },
    ],
  },
  {
    text: "Finished 10th among 3,062 participants in the 24-hour HackerRank Orchestrate September edition. Built Buy or Wait? using message and document evidence, deterministic 90-day cash forecasts, and independent safety checks to choose payment plans.",
    links: [
      {
        kind: "github",
        href: "https://github.com/VIVPM/hackerrank-buy-or-wait",
      },
      {
        kind: "certificate",
        href: HackerRankSeptCert,
      },
    ],
  },
  {
    text: "Finished 30th among 1,900+ participants in the 24-hour HackerRank Orchestrate August edition. Built multimodal WhatsApp notification routing with OCR, speech transcription, four tool-calling agents, and deterministic safety rules.",
    links: [
      {
        kind: "github",
        href: "https://github.com/VIVPM/hackerrank-message-notification-router-hackathon",
      },
      {
        kind: "certificate",
        href: HackerRankAugCert,
      },
    ],
  },
  {
    text: "Finished 30th among 1700+ participants in the 24-hour HackerRank Orchestrate June edition. Built vision-language damage-claim review with deterministic rules that escalate weak evidence.",
    links: [
      {
        kind: "github",
        href: "https://github.com/VIVPM/hackerrank-multi-modal-evidence-review-hackathon",
      },          {
        kind: "certificate",
        href: HackerRankJuneCert,
      },

    ],
  },
  {
    text: "Finished 59th among 1,300+ participants in the 24-hour HackerRank Orchestrate May edition. Built support-ticket triage with local RAG, hybrid retrieval, structured reasoning, and escalation for high-risk cases.",
    links: [
      {
        kind: "github",
        href: "https://github.com/VIVPM/hackerrank-support-triage-system-hackathon",
      },          {
        kind: "certificate",
        href: HackerRankMayCert,
      },

    ],
  },
  {
    text: "Placed 4th in the CuraLink Hackathon v2.0 run by Humanity Founders. Built clinical RAG research using PubMed, OpenAlex, ClinicalTrials.gov, PubMedBERT, and MedCPT.",
    links: [
      {
        kind: "github",
        href: "https://github.com/VIVPM/curalink-medical-assistant",
      },          {
        kind: "certificate",
        href: CuraLinkCert,
      },

    ],
  },
  // Kaggle activity parked for now.
  // {
  //   text: "Placed 1233rd of 4000+ in Kaggle Playground Series S6E2 (Heart Disease Prediction), scoring 0.95510 ROC-AUC with a CatBoost classifier tuned via 50 Optuna trials.",
  //   links: [
  //     {
  //       kind: "kaggle",
  //       href: "https://www.kaggle.com/competitions/playground-series-s6e2/leaderboard?search=VIVEK%20PM",
  //     },
  //     {
  //       kind: "github",
  //       href: "https://github.com/VIVPM/heart-disease-prediction",
  //     },
  //   ],
  // },
];

export const experiences = [
  {
    id: 4,
    current: true,
    img: "https://d1cg29ukvkl76a.cloudfront.net/media_files/publicmedia/a704861d83499399a0a71d0445f90e8218812220590e9f570537f6ad2b0f4fbd/profile_search-78004_experience_logo.jpg",
    role: "AI Engineer",
    company: "Self Employed",
    employment: "Freelance",
    date: "April 2026 - Present",
    location: "Remote",
    points: [
      { text: "Reduced the RAG search space by 99.7% through an eight-stage sequential evaluation strategy." },
      { text: "Cut cross-encoder inference from 40k to 29k candidate pairs through deduplication and score caching." },
      { text: "Increased complete-evidence retrieval from 81.8% to 88.2% by reranking the top 20 candidates with BGE." },
      { text: "Limited Gemini generation and evaluation costs to $2.63 for 2,500 answers through batching and controlled token budgets." },
      { text: "Developed faculty profiling workflow that converts complete faculty records into concise, evidence-grounded professional summaries." },
      { text: "Implemented faculty discovery system using Qdrant hybrid search to identify relevant experts from qualifications, experience and academic contributions, with source-supported rankings." },
    ],
    skills: [
      "Python",
      "Retrieval-Augmented Generation (RAG)",
      "Qdrant",
      "Hybrid Search",
      "Cross-Encoder Reranking",
      "BGE",
      "Gemini",
      "LLM Evaluation",
    ],
    doc: "",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7FzOQxpSubpkqNI5YPL1c92jGvkiq3IEiJQ&s",
    role: "AI Engg Intern (Outamation Extern)",
    company: "Extern",
    date: "December 2025 - February 2026",
    employment: "Externship",
    location: "Remote",
    detail:
      "Built a Document Retrieval System for 100+ page mortgage documents using LlamaIndex and Python, reducing document query time from 10 minutes to 10 seconds. Cut ingestion latency from 160s to 45s via concurrent page classification, embedding and boundary detection. Built a Hybrid RAG system combining dense-sparse vectors in Pinecone, improving F1 score from 89% to 94%. Applied the RAGAS evaluation framework for 250 queries, achieving a Context Recall of 98% across the test suite.",
    skills: [
      "Generative AI",
      "Retrieval-Augmented Generation (RAG)",
      "LlamaIndex",
      "Pinecone",
      "Hybrid Search",
      "Cross-Encoder Reranking",
      "RAGAS",
      "Python",
    ],
    doc: "",
  },
  {
    id: 0,    img: Pravinya,
    role: "Machine Learning Intern",
    company: "Pravinya Information Technology Services",
    date: "April 2025 - October 2025",
    employment: "Internship",
    location: "Hubli, Karnataka, India",
    detail:
      "Developed health insurance model to predict premium prices for users based on demographic and health data. Enhanced model interpretability through 20% reduction in the feature set via multicollinearity analysis (VIF), enabling clearer insights for decision-making. Optimized model performance by selecting XGBoost over Random Forest, reducing RMSE from Rs. 2000 to Rs. 1300. Performed residual error analysis on model predictions revealing 30% of predictions with more than 10% deviation, traced the root cause to the young age segment, and recommended additional feature collection. Presented model findings to client stakeholders through React web app, translating technical insights into actionable recommendations.",
    skills: [
      "Machine Learning",
      "Exploratory Data Analysis",
      "Python",
      "Numpy",
      "Pandas",
      "Scikit-Learn",
      "XGBoost",
      "Matplotlib",
      "React",
      "Optuna",
    ],
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "https://img.collegepravesh.com/2018/10/KLE-Tech-University-Logo.png",
    school: "KLE Technological University, Hubli",
    date: "December 2020 - June 2024",
    grade: "9.58 CGPA",
    desc: "I completed my Bachelor's degree in Computer Science and Engineering at KLE Technological University, Hubli. I have a CGPA of 9.58. I have studied Data Structures and Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, Blockchain and Computer Networks courses.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://4.bp.blogspot.com/-ITj7aaqU3_c/WC8eqns-DoI/AAAAAAAAJSU/fCo98EgzN5IyGTuf76bzM3RMBq-Hs7hRQCLcB/s1600/vi.png",
    school: "Vidyaniketan P.U Science College, Hubli",
    date: "May 2018 - March 2020",
    grade: "94.4%  KCET: 1734",
    desc: "I completed my first and second year of P.U.at Vidyaniketan P.U.Science College, Hubli, where I studied PCM along with Statistics.",
    degree: "PCM with Statistics",
  },
];

export const projects = [
  // --- hidden from the site (kept for reference) ---
  // {
  //   id: 4,
  //   title: "Customer Churn Prediction",
  //   date: "",
  //   description:
  //     "Churn prediction using SVM, Random Forest, Logistic Regression, and Decision Tree trained on multi-source Excel data (transactions, service, activity). GridSearchCV hyperparameter tuning, Z-score outlier detection, correlation-based feature selection, and SHAP explainability. FastAPI backend and Streamlit UI for single and batch predictions. Models versioned and stored on Hugging Face Hub.",
  //   image:
  //     "https://www.scnsoft.com/blog-pictures/business-intelligence/customer-churn-analysis.png",
  //   tags: [
  //     "Python",
  //     "Scikit-learn",
  //     "FastAPI",
  //     "Streamlit",
  //     "Hugging Face",
  //     "Jupyter Notebook",
  //   ],
  //   category: "AI/ML",
  //   github: "https://github.com/VIVPM/customer-churn-prediction",
  //   webapp: "https://customer-churn-prediction-vpm.streamlit.app/",
  // },
  // Expense Tracker App parked. Restore by uncommenting.
  // {
  //   otherOrder: 5,
  //   id: 13,
  //   title: "Expense Tracker App",
  //   date: "",
  //   description:
  //     "Full-stack expense tracker with expense logging, budget management and Recharts visualisations. A React (Vite) frontend styled in Tailwind CSS sits on a Python FastAPI backend using SQLAlchemy ORM and JWT authentication. Google GenAI generates spending insights from the logged data.",
  //   image:
  //     "https://www.mindinventory.com/blog/wp-content/uploads/2021/06/expense-tracking-app.webp",
  //   tags: [
  //     "React",
  //     "Vite",
  //     "Tailwind CSS",
  //     "Python",
  //     "FastAPI",
  //     "SQLAlchemy",
  //     "Recharts",
  //     "Google GenAI",
  //   ],
  //   category: "WEB TECHNOLOGY",
  //   github: "https://github.com/VIVPM/expense-tracker-app",
  //   webapp: "https://expense-tracker-app-frontend-7bnp.onrender.com",
  // },
  // --- hidden from the site (kept for reference) ---
  // {
  //   id: 14,
  //   title: "Job Searching Platform",
  //   date: "",
  //   description:
  //     "Developed a web application  for Job platform for recruiters and job seekers where job seekers can apply for jobs, build and upload resumes and recruiters can post and update the job, update the status of application and send emails for acceptance notifications.",
  //   image:
  //     "https://cdn.prod.website-files.com/6128ada90655fc258bfa9d75/651ce5f13d4234857751ac0c_brd.jpg",
  //   tags: [
  //     "ReactJS",
  //     "NodeJS",
  //     "ExpressJS",
  //     "MongoDB",
  //     "Firebase",
  //     "EmailJS",
  //     "Material-UI",
  //     "VS Code",
  //   ],
  //   category: "WEB TECHNOLOGY",
  //   github: "https://github.com/VIVPM/job-portal-internship",
  //   webapp: "https://job-portal-frontend-4aul.onrender.com",
  // },
  // --- hidden from the site (kept for reference) ---
  // {
  //   id: 15,
  //   title: "Security Guard Management System",
  //   date: "",
  //   description:
  //     "Developed a security guard management system which includes user authentication, background check, crud operations on users, reporting incidents, recording attendance, showing routes, and tracking user.",
  //   image:
  //     "https://www.efacility.in/wp-content/uploads/2019/05/Patrol-Management-Banner-1.png",
  //   tags: [
  //     "MERN Stack",
  //     "Cloudinary",
  //     "Material-UI",
  //     "Cursor",
  //     "OpenStreet Map",
  //   ],
  //   category: "WEB TECHNOLOGY",
  //   github: "https://github.com/VIVPM/security-guard/",
  //   webapp: "https://security-guard-frontend-o3vx.onrender.com",
  // },
  // {
  //     id: 16,
  //     title: "Sports Person Image Classification",
  //     date: "",
  //     description:
  //         "Classisifcation of five sports person using UI, backend server and trained model using CNN.",
  //     image:
  //         "https://images.codebasics.io/fit-in/600x600/images/1.1.419/courses/thumbnails/data-science-project-sports-celebrity-image-classification.webp",
  //     tags: [
  //         "Python",
  //         "cv2",
  //         "Jupyter Notebook",
  //         "HTML",
  //         "CSS",
  //         "JavaScript",
  //         "Cursor"
  //     ],
  //     category: "AI/ML",
  //     github: "https://github.com/VIVPM/Sports-Person-Image-Classification",
  //     webapp: "",
  // },
  // {
  //     id: 17,
  //     title: "Potato Disease Classification",
  //     date: "",
  //     description:
  //         "Develped a web application which takes potato leaf input as image, runs the model at backend server, and fetch the class label for that particular input.",
  //     image:
  //         "https://i.ytimg.com/vi/XM7sg99a5no/sddefault.jpg",
  //     tags: [
  //         "Python",
  //         "CNN",
  //         "Postman",
  //         "Docker",
  //         "FastAPI",
  //         "Jupyter Notebook",
  //         "Cursor"
  //     ],
  //     category: "AI/ML",
  //     github: "https://github.com/VIVPM/Potato-Disease-Classification",
  //     webapp: "https://potato-disease-classification-frontend.onrender.com/",
  // },
  // --- hidden from the site (kept for reference) ---
  // {
  //     id: 20,
  //     title: "Equity Research Tool",
  //     date: "",
  //     description:
  //         "A user-friendly news research tool designed for effortless information retrieval. Users can input article URLs and ask questions to receive relevant insights from the stock market and financial domain.",
  //     image:
  //         "https://raw.githubusercontent.com/parthgoel1204/Equity-Research-Tool-/main/screenshots/main_interface.png",
  //     tags: [
  //         "Python",
  //         "Streamlit",
  //         "Postman",
  //         "Cursor",
  //         "Gemini",
  //         "Jupyter Notebook",
  //     ],
  //     category: "GENERATIVE AI",
  //     github: "https://github.com/VIVPM/Equity-Research-Tool",
  //     webapp: "",
  // },
  // Heart Disease Prediction parked. Restore by uncommenting.
  // {
  //   otherOrder: 4,
  //   id: 5,
  //   title: "Heart Disease Prediction",
  //   date: "",
  //   description:
  //     "CatBoost classifier for heart disease prediction trained on 630K records, tuned across 50 Optuna trials to a 0.9562 ROC-AUC. A Python FastAPI backend and Streamlit UI handle single and batch predictions. Training runs on a Modal T4 GPU when deployed and falls back to CPU locally, with models versioned on Hugging Face Hub.",
  //   image:
  //     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkz6s_bnSauj03tp85bOt8wqFaxkyYBsFA3A&s",
  //   tags: [
  //     "Python",
  //     "CatBoost",
  //     "Optuna",
  //     "FastAPI",
  //     "Streamlit",
  //     "Modal",
  //     "Hugging Face",
  //   ],
  //   category: "AI/ML",
  //   github: "https://github.com/VIVPM/heart-disease-prediction",
  //   webapp: "https://heart-disease-prediction-vpm.streamlit.app/",
  // },
  // Log Classification System parked. Restore by uncommenting.
  // {
  //   otherOrder: 2,
  //   id: 6,
  //   title: "Log Classification System",
  //   date: "",
  //   description:
  //     "Hybrid log classifier that routes each record by source and data availability: regex for predictable patterns, Sentence Transformers embeddings with logistic regression for labelled complex patterns, and a Gemini LLM where training data is thin. Python and FastAPI process CSV uploads, with a React (Vite) frontend for interactive classification.",
  //   image:
  //     "https://raw.githubusercontent.com/VIVPM/log-classification-system/main/arch.png",
  //   tags: [
  //     "Python",
  //     "Regex",
  //     "Sentence Transformers",
  //     "Logistic Regression",
  //     "Gemini",
  //     "FastAPI",
  //     "React",
  //     "Vite",
  //   ],
  //   category: "AI/ML",
  //   github: "https://github.com/VIVPM/log-classification-system/",
  //   webapp: "https://log-classification-system-frontend.onrender.com",
  // },
  {
    featured: true,
    featuredOrder: 1,
    id: 10,
    title: "Agentic Leads Dashboard",
    date: "",
    description:
      "Upload your sales leads and get back the ranked shortlist worth chasing, each one with its outreach email already written. It researches every person and their company, scores how well they fit what you sell, and drafts the email only when that fit is strong, so your sales representatives spend the day on the ten leads that matter instead of the hundred that do not.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBEe_F2O_pVM_WkNO1QiQMTyGkZoe15__IrQ&s",
    evidence: {
      result: "Lead-fit classification on 32 clear-label cases in the 60-lead evaluation: 31/32 correct (96.9%).",
      challenge: "I wanted sales reps to spend time on leads that fit their product, not send the same email to every name in a CSV. I also needed to avoid researching the same company from scratch for every person who worked there.",
      decision: "I split company research, personal research, scoring, and email drafting into separate LangGraph steps. The score uses fixed demographic, firmographic, and behavioral budgets; company research is cached by company and ICP. I draft automatically only above 70, while borderline leads stay available for manual review.",
      limit: "I tested lead-fit labels, not whether any email won customers. Three evaluation labels changed after review, and only 2 of 10 borderline leads landed in the target band. I would tune that band and measure outreach outcomes before claiming sales impact.",
    },
    tags: [
      "Python",
      "CrewAI",
      "FastAPI",
      "React",
      "Supabase",
      "Gemini",
      "Tavily",
    ],
    category: "GENERATIVE AI",
    github: "https://github.com/VIVPM/multi-crew-leads-dashboard",
    webapp: "https://multi-crew-leads-dashboard-frontend.onrender.com/",
  },
  // {
  //     id: 24,
  //     title: "Audio Transcript Q&A App",
  //     date: "",
  //     description:
  //         "Audio-Q&A App transcribes MP3 files, indexes the content using embeddings, and answers user questions based on the audio using Amazon Bedrock and Pinecone.",
  //     image:
  //         "https://imgs.search.brave.com/jIieC4q32Zee_vcVUM_lfJ4NzR5vMk02aktwaYEmR_Y/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4t/aWNvbnMtcG5nLmZs/YXRpY29uLmNvbS8x/MjgvODA3MC84MDcw/MjMxLnBuZw",
  //     tags: [
  //         "Python",
  //         "Streamlit",
  //         "AWS Bedrock",
  //         "Pinecone",
  //         "Cursor"
  //     ],
  //     category: "GENERATIVE AI",
  //     github: "https://github.com/VIVPM/Audio-Q-A-App",
  //     webapp: "",
  // },
  // Quickbrain - A Mini Chatbot parked. Restore by uncommenting.
  // {
  //   otherOrder: 6,
  //   id: 12,
  //   title: "Quickbrain - A Mini Chatbot",
  //   date: "",
  //   description:
  //     "Streamlit RAG chat app for querying your own PDFs. Uploaded documents are embedded with bge-large and stored in Pinecone, then answered by a SambaNova LLM through LangChain, with optional web search. Python throughout, with users and chat history persisted in Supabase.",
  //   image:
  //     "https://imgs.search.brave.com/9WB7G15X-T900X_71a18B3SMW5jt2Dy6pT3YIneHx54/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly90My5m/dGNkbi5uZXQvanBn/LzA2LzAxLzU1Lzcy/LzM2MF9GXzYwMTU1/NzIxNV9pSmtNT3p5/ejBndTgwT1RBYXh0/NXdFdUNHRTNqeXF4/eC5qcGc",
  //   tags: [
  //     "Python",
  //     "Streamlit",
  //     "LangChain",
  //     "Pinecone",
  //     "SambaNova",
  //     "Supabase",
  //     "RAG",
  //   ],
  //   category: "GENERATIVE AI",
  //   github: "https://github.com/VIVPM/langchain_conversational_chatbot",
  //   webapp: "https://quickbrain-chatapp.streamlit.app/",
  // },
  // --- hidden from the site (kept for reference) ---
  // {
  //   id: 11,
  //   title: "Startup Idea Validator",
  //   date: "",
  //   description:
  //     "An autonomous AI-powered market research and business analysis system built with CrewAI and deployed as a Streamlit web app. Five specialized agents (Market Research Specialist, Competitive Intelligence Analyst, Customer Insights Researcher, Product Strategy Advisor, Business Analyst) execute a sequential pipeline covering TAM/SAM/SOM sizing, competitor mapping, customer personas, MVP strategy, and a full business report, achieving an overall average score of 9.6/10 in testing.",
  //   image:
  //     "https://www.shutterstock.com/shutterstock/videos/1016562451/thumb/10.jpg?ip=x480",
  //   tags: [
  //     "Python",
  //     "CrewAI",
  //     "Streamlit",
  //     "Gemini",
  //     "SerperDev",
  //     "LiteLLM",
  //     "Cursor",
  //   ],
  //   category: "GENERATIVE AI",
  //   github: "https://github.com/VIVPM/market_research_crew",
  //   webapp: "https://market-research-crew-vpm.streamlit.app/",
  // },
  {
    otherOrder: 4,
    id: 1,
    title: "Book Recommender System",
    date: "",
    description:
      "Suggests the next book to read based on what other people with similar taste enjoyed. Search for any title you liked and it returns close matches drawn from real readers' ratings, rather than from whatever the publisher happens to be promoting.",
    image:
      "https://user-images.githubusercontent.com/114379464/235067070-ba0f6652-847d-4b7d-97ca-962b3dee51ef.png",
    evidence: {
      result: "Hit rate at 5 on up to 500 sampled Book-Crossing users (leave-one-out liked book): 42.07%; ranking quality NDCG@5: 29.62%.",
      challenge: "The Book-Crossing ratings matrix is sparse: most readers have rated only few books in the catalogue. I needed recommendations that use those ratings without treating unrated books as books readers disliked.",
      decision: "I built the book-user matrix and used cosine KNN to find nearby titles. For the offline check, I gave the model one book the user rated highly and looked for other books that user also liked in the top five. I tracked training runs and model versions with MLflow so the served model could be tied back to its evaluation.",
      limit: "Books can be good recommendations even if the user never rated them, so offline hit rate counts some useful suggestions as misses. I would test reader clicks and saves before treating this score as measuring the product experience.",
    },
    tags: [
      "Python",
      "Scikit-learn",
      "KNN",
      "FastAPI",
      "React",
      "Vite",
      "Docker",
      "MLflow",
      "DagsHub",
      "AWS",
    ],
    category: "AI/ML",
    github: "https://github.com/VIVPM/book-recommendation-system-new",
    webapp: "",
  },
  {
    featured: true,
    featuredOrder: 4,
    id: 9,
    title: "E-commerce Agent",
    date: "",
    description:
      "Search the live product catalogue, compare saved items, and ask about store policies in plain language. The agent routes each request to catalogue search, policy retrieval, or shopping actions; it asks for clarification before cancelling an unspecified order.",
    image:
      "https://razorse.com/blog/wp-content/uploads/2024/12/Ecommerce-Chatbots-How-to-Improve-the-Usability-of-Your-Web-Store-1-2.png",
    evidence: {
      result: "Average response time across 200 product, policy and adversarial test scenarios: 12.5s/case with Flash vs 31.4s/case in the earlier Pro-based run.",
      challenge: "Shopping agents have to answer against the current catalogue and policy data, then understand follow-ups such as 'save 2' without confusing saved items with an order. An ambiguous cancellation should never turn into an action on the wrong purchase.",
      decision: "I kept catalogue search in read-only SQL, store policies in their own retrieval tool, and saved items and orders in user-scoped tools. The agent chooses one tool or none; tools return their checked results directly rather than asking another model to paraphrase them. After measuring the Pro-based version, I moved routing and SQL generation to Flash and kept explicit guards for unsupported filters and ambiguous actions.",
      limit: "The 200 scenarios and model judge test routing and answer quality, not whether shoppers bought anything. I would test longer conversations and live catalogue changes with users before claiming fewer mistakes in real orders.",
    },
    tags: [
      "Python",
      "FastAPI",
      "React",
      "Vite",
      "Gemini",
      "Pinecone",
      "Postgres",
      "Text-to-SQL",
    ],
    category: "GENERATIVE AI",
    github: "https://github.com/VIVPM/ecommerce-agent",
    webapp: "https://ecommerce-agent-frontend-kihh.onrender.com",
  },
  {
    otherOrder: 1,
    id: 19,
    title: "Message Notification Router",
    date: "",
    description:
      "Routes WhatsApp text, screenshots, and voice notes to notify, digest, or mute using message history and safety signals. Built for the HackerRank Orchestrate challenge, not deployed for live messaging.",
    evidence: {
      result: "Routing action agreement on 30 labeled development messages: 80%. All 110 hidden-set submissions had valid output rows, not scored accuracy.",
      challenge: "The same notification can be useful for one person and noise for another. Text-only routing also misses what is said in voice notes or written on images, while scams and prompt-injection text should not get to steer the decision.",
      decision: "I transcribed audio with Whisper, read images with Qwen3-VL, and retrieved relevant reactions from the user's message history. Deterministic safety rules can mute risky content before the four agents handle triage, context, and evidence. I clamp every cited history ID to real messages and run requests with bounded concurrency so the output stays in input order.",
      limit: "Action agreement was 80% on 30 solved development messages. The 110 submission labels are hidden, so I cannot call the output accuracy. I would inspect the disagreements and test more users before trusting the personalization in daily use.",
    },
    tags: [
      "Python",
      "Whisper",
      "Qwen3-VL",
      "Multi-Agent",
      "OCR",
      "Hugging Face",
    ],
    category: "GENERATIVE AI",
    github: "https://github.com/VIVPM/hackerrank-message-notification-router-hackathon",
  },
  {
    otherOrder: 2,
    id: 20,
    title: "Multi-Modal Evidence Review",
    date: "",
    description:
      "Checks whether claim photos support the reported damage to cars, laptops, or parcels. Sends weak or mismatched evidence to manual review instead of forcing approval.",
    evidence: {
      result: "Claim-status accuracy on 20 labeled damage claims: 85% with Qwen2.5-VL-72B vs 75% with each Qwen3-VL model tested.",
      challenge: "Damage photos can show the wrong part, the wrong object, or no visible damage at all. Claims and images can also contain text telling the model what verdict to give, which is not evidence of damage.",
      decision: "I made one vision call per claim to restate the reported damage and inspect the pixels together. I compared four vision models on 20 labeled claims and chose Qwen2.5-VL-72B because the larger candidates approved too many adversarial cases. After the model responds, rules validate enums and image IDs; user-history flags can add risk but cannot overturn the visual verdict.",
      limit: "The 20-case labeled set is small. Issue type and severity reached only 55% and 50% accuracy, so I would collect more labeled edge cases and keep manual review for weak evidence rather than automate those judgments.",
    },
    tags: [
      "Python",
      "Qwen2.5-VL",
      "Vision-Language Models",
      "Structured Output",
      "Hugging Face",
    ],
    category: "GENERATIVE AI",
    github: "https://github.com/VIVPM/hackerrank-multi-modal-evidence-review-hackathon",
  },
  {
    otherOrder: 3,
    id: 21,
    title: "Support Ticket Triage System",
    date: "",
    description:
      "Sorts support tickets across three product knowledge bases. It answers from local documentation when evidence is sufficient and escalates fraud, account-access, or unsupported requests.",
    evidence: {
      result: "Routing outcomes on 29 HackerRank challenge tickets: 11 source-grounded replies, 18 escalations; all 29 rows passed the output schema.",
      challenge: "Support tickets mix answerable product questions with account-access requests, fraud, abuse, and gaps in the documentation. I did not want language models writing confident replies when the corpus could not support one.",
      decision: "I put deterministic sanitization, company routing, and high-risk rules ahead of model calls. For on-topic tickets I fused company-scoped BM25 and dense retrieval, generated structured answers from the retrieved passages, then ran another groundedness check. Anything unsafe, ambiguous, or unsupported goes to human review instead of being marked replied.",
      limit: "The 11 replies and 18 escalations describe what my system decided on 29 challenge tickets, not measured accuracy. I would need independently labeled tickets and support-team review to know which escalations or replies were right.",
    },
    tags: [
      "Python",
      "Llama 3.3",
      "RAG",
      "BM25",
      "Hybrid Retrieval",
      "Hugging Face",
    ],
    category: "GENERATIVE AI",
    github: "https://github.com/VIVPM/hackerrank-support-triage-system-hackathon",
  },
  {
    otherOrder: 5,
    id: 2,
    title: "Fake News Detection",
    date: "",
    description:
      "Reads news articles and flags the ones that look fabricated, in the time it takes to paste the text in. It learned the difference from thousands of genuine and invented stories, and scores whole batches in one go so you can check many articles at once rather than one by one.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKlvciQmQP1ZTW1KjE6d4ckPUIUh-zgDzLSA&s",
    evidence: {
      result: "Article classification accuracy on 8,980 held-out articles (20% stratified test split): 97.96% in the training notebook.",
      challenge: "I wanted to classify article text in batches, but scores on labeled news datasets differ from checking whether new claims are true. The service also needed to load the trained model without bringing the training notebook into the API.",
      decision: "I trained bidirectional LSTM with GloVe embeddings on labeled real and fake articles, using stratified 20% test split. I exported the model to ONNX and served predictions through FastAPI so the frontend can submit one article or batches without running the training stack.",
      limit: "The 97.96% figure comes from 8,980 held-out articles in that dataset. I would test newer publishers and out-of-distribution stories separately; this classifier cannot verify individual facts in an article.",
    },
    tags: [
      "Python",
      "NLTK",
      "LSTM",
      "ONNX",
      "FastAPI",
      "React",
      "Hugging Face",
    ],
    category: "AI/ML",
    github: "https://github.com/VIVPM/fake-news-detection",
    webapp: "https://fake-news-detection-frontend-9eqd.onrender.com",
  },
  {
    otherOrder: 6,
    id: 3,
    title: "Credit Risk Modeling",
    date: "",
    description:
      "Estimates each loan applicant's probability of default and maps it to credit score and risk rating. The model favors catching defaults in its test set, accepting more false alarms rather than missing high-risk cases.",
    evidence: {
      result: "Default-class recall on 12,500 labeled test loans (1,074 defaults): 96%, with 52% precision for flagged defaults.",
      challenge: "Defaults are the minority of the loan records, so overall accuracy can look good while the model misses borrowers who default. Raising recall also creates false alarms that lenders would have to review.",
      decision: "I merged customer, loan, and bureau records, engineered debt and delinquency features, and used undersampling before tuning logistic regression. I evaluated the default class separately, then mapped predicted default probability to the application's 300–900 score and risk bands.",
      limit: "On 12,500 labeled test loans the model recalled 96% of defaults, but only 52% of flagged loans were defaults. I would check calibration, performance across applicant groups, and future cohorts before using the score in lending decisions.",
    },
    tags: [
      "Python",
      "Scikit-learn",
      "Logistic Regression",
      "Optuna",
      "FastAPI",
      "React",
    ],
    category: "AI/ML",
    github: "https://github.com/VIVPM/credit-risk-model",
    webapp: "https://credit-risk-model-2-r4hf.onrender.com",
  },
  {
    featured: true,
    featuredOrder: 2,
    id: 8,
    title: "Document Retrieval System",
    date: "",
    description:
      "Loan-file copilot for mortgage officers. It reviews an application against supporting documents, flags mismatches with page citations, and answers follow-up questions from the uploaded packet.",
    image:
      "https://static.vecteezy.com/system/resources/previews/047/191/074/non_2x/tax-research-audit-concept-or-list-of-paper-pages-through-magnifying-glass-flat-cartoon-tax-payment-analysis-of-data-documents-financial-research-reports-and-calculations-debt-payments-vector.jpg",
    evidence: {
      result: "Answer correctness on 250 questions about one 50-page mortgage packet (RAGAS): 222 fully correct with hybrid search vs 207 with vector-only search.",
      challenge: "Mortgage packets mix tables, forms, and narrative pages. Officers need exact values and page references; plausible answers without the right source are not useful for reviewing loan files.",
      decision: "I extract forms and tables with Textract, add document identity to chunks, and combine BM25 with embeddings so exact fields and paraphrased questions both reach the results. The Postgres job queue keeps ingestion alive across API restarts. I keep page citations tied to stored source pages, and use code rather than the model for the automatic field comparisons.",
      limit: "Hybrid search produced 222 fully correct answers on 250 questions from one 50-page evaluation packet, compared with 207 for vector search alone. I would test more lenders' document layouts and measure actual officer review time before claiming workflow savings.",
    },
    tags: [
      "Python",
      "FastAPI",
      "React",
      "Pinecone",
      "BM25",
      "AWS Textract",
      "Neon Postgres",
      "Gemini",
      "RAG",
    ],
    category: "GENERATIVE AI",
    github: "https://github.com/VIVPM/document-retrieval-system",
    webapp: "https://document-retrieval-system-frontend.onrender.com",
  },
  {
    featured: true,
    featuredOrder: 3,
    id: 18,
    title: "Curalink Medical Research Assistant",
    date: "",
    description:
      "Searches PubMed, OpenAlex, and ClinicalTrials.gov for research tied to each medical question. It ranks the sources, presents cited findings, and keeps emergency and diagnosis requests outside the research workflow.",
    image:
      "https://media.istockphoto.com/id/2222271498/vector/doctor-robot.jpg?s=612x612&w=0&k=20&c=d_6LqFXTMihs5EmvJHmgddUi0B5PXJeRlw00lltQ6_A=",
    evidence: {
      result: "Pipeline quality on 50 live evaluation queries: 47/50 passed all checks; 39/42 medical answers passed the citation-presence check.",
      challenge: "Medical questions need recent, inspectable sources, and PubMed, OpenAlex, and ClinicalTrials.gov return different kinds of records. Keyword and embedding scores are not on the same scale, while emergency or diagnosis requests should not be treated as research queries.",
      decision: "I retrieve from the three sources in parallel, deduplicate their records, fuse BM25 and PubMedBERT by rank rather than raw score, and rerank the source-balanced shortlist with MedCPT. The response includes source details for checking the original paper. I route urgent requests away from the research pipeline and keep the product outside diagnosis or treatment decisions.",
      limit: "The 50-query harness checks structure and citation presence, not medical entailment or clinical safety. I would need expert review of the cited claims and faster retrieval on the free-tier path before treating the system as dependable research support.",
    },
    tags: [
      "React",
      "Express",
      "MongoDB",
      "FastAPI",
      "Python",
      "PubMedBERT",
      "MedCPT",
      "Redis",
      "RAG",
    ],
    category: "GENERATIVE AI",
    github: "https://github.com/VIVPM/curalink-medical-assistant",
    webapp: "https://curalink-medical-assistant-frontend.onrender.com",
  },
];
